import * as React from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  FormHelperText,
  InputAdornment,
  Input,
  withStyles,
  Button,
  Paper,
  Typography,
  Tooltip,
} from "@material-ui/core";
import {
  Mail,
  AddCircleOutline as Unverified,
  CheckCircle as Check,
} from "@material-ui/icons";
import DropdownUploadImage from "modules/profile/components/layouts/DropdownUploadImage";
import AccountButton from "common/components/AccountButton";
import { ProfileService } from "modules/profile/ProfileService";
import { ProfileStore } from "modules/profile/ProfileStore";
import { LoginStore } from "modules/login/LoginStore";
import { DevelopmentService } from "modules/development/DevelopmentService";
import i18n from "i18n";
import { observer } from "mobx-react";
import { createBlankUser } from "modules/login/models/User";
import { default as firebase } from "common/Firebase";
import Padlock from "common/icons/Padlock";
import { WBSStore } from "modules/WBS/WBSStore";

const styles = (theme) => ({});

type IProps = {
  classes: any;
  password: any;
};

@observer
class Profile extends React.Component<IProps> {
  state = {
    name:
      LoginStore.userAuth != undefined ? LoginStore.userAuth.displayName : "",
    email: LoginStore.userAuth != undefined ? LoginStore.userAuth.email : "",
    disabled: false,
    userAuth: false,
    collection: "",
    companyName: ProfileStore.companyName != "" ? ProfileStore.companyName : "",
    companyLogo: ProfileStore.companyLogoURL,
    companyUsers: [],
  };

  handleInputNameChangeEvent = (e) => {
    this.setState({ name: e.target.value });
    ProfileStore.disabledBtn = false;
  };
  handleInputEmailChangeEvent = (e) => {
    this.setState({ email: e.target.value });
    ProfileStore.disabledBtn = false;
  };
  handleInputDeleteOrphanCollection = (e) => {
    this.setState({ collection: e.target.value });
  };

  handleSendEmailVerification = () =>
    ProfileService.sendEmailVerification(this.sendEmailVerificationCallback);

  handleResetPassword = () =>
    ProfileService.resetPassword(
      LoginStore.userAuth != undefined ? LoginStore.userAuth.email : "",
      this.resetPasswordCallback
    );

  sendEmailVerificationCallback = (response) => {
    if (response === true)
      ProfileStore.message =
        i18n.firebaseFunctions.sendEmailVerification.success;
    else
      ProfileStore.message = i18n.firebaseFunctions.sendEmailVerification[
        response.code
      ]
        ? i18n.firebaseFunctions.sendEmailVerification[response.code]
        : i18n.firebaseFunctions.sendEmailVerification.error;
    ProfileStore.openSnackbar = true;
  };

  /**
   * Executa rotina para atualizar dados de perfil do usuário.
   * @method handleSave
   * @category Users
   * @see {@link DevelopmentService#addImage}
   * @see {@link DevelopmentService#getImage}
   * @see {@link ProfileService#updateProfileEmail}
   */
  handleSave = () => {
    ProfileStore.disabledBtn = true;
    this.setState({ disabled: true }, async () => {
      let update = {
          displayName: this.state.name,
          photoURL: ProfileStore.url,
          providerId: ProfileStore.providerId,
        },
        user =
          LoginStore.userAuth != undefined
            ? LoginStore.userAuth
            : createBlankUser(),
        change = false;
      if (ProfileStore.file) {
        await DevelopmentService.addImage(ProfileStore.file, user.uid);
        update.photoURL = await DevelopmentService.getImage({
          imageName: user.uid + ProfileStore.file.name,
        });
        change = true;
      }
      if (
        user.displayName !== update.displayName ||
        user.photoURL !== update.photoURL
      ) {
        let user = ProfileService.getAuthData();
        let uid = "";
        if (user) {
          uid = user.uid;
        }
        let id =
          LoginStore.userAuth != undefined ? LoginStore.userAuth.uid : "";

        // Chama a função do firebase
        const updateProfileInfos = firebase
          .functions()
          .httpsCallable("updateProfileInfos");
        updateProfileInfos({
          uid,
          id,
          update,
          displayName: update.displayName,
          photoURL: update.photoURL,
        });

        this.updateProfileInfosCallback(true);

        if (LoginStore.userAuth != undefined) {
          let temp = { ...LoginStore.userAuth };
          temp.photoURL = update.photoURL;
          temp.displayName = update.displayName;
          LoginStore.userAuth = temp;
        }
        change = true;
      } else if (
        ProfileStore.password &&
        LoginStore.userAuth != undefined &&
        LoginStore.userAuth.email !== this.state.email
      ) {
        ProfileService.updateProfileEmail(
          LoginStore.userAuth,
          this.state.email,
          this.updateProfileEmailCallback
        );
        change = true;
      }
      if (!change) {
      }
    });
  };

  handleOpenModalLinkCredencial = () =>
    (ProfileStore.ModalLinkCredencial = true);

  updateProfileInfosCallback = (response) => {
    if (response === true) {
      ProfileStore.message = i18n.firebaseFunctions.updateProfile.success;
      if (
        LoginStore.userAuth != undefined &&
        LoginStore.userAuth.email !== this.state.email
      )
        ProfileService.updateProfileEmail(
          LoginStore.userAuth,
          this.state.email,
          this.updateProfileEmailCallback
        );
      else this.setState({ disabled: false });
    } else {
      ProfileStore.message = i18n.firebaseFunctions.updateProfile[response.code]
        ? i18n.firebaseFunctions.updateProfile[response.code]
        : i18n.firebaseFunctions.updateProfile.error;
      this.setState({ disabled: false });
    }
    ProfileStore.openSnackbar = true;
  };

  updateProfileEmailCallback = (response) => {
    if (response === true)
      ProfileStore.message = i18n.firebaseFunctions.updateEmail.success;
    else
      ProfileStore.message = i18n.firebaseFunctions.updateEmail[response.code]
        ? i18n.firebaseFunctions.updateEmail[response.code]
        : i18n.firebaseFunctions.updateEmail.error;
    ProfileStore.openSnackbar = true;
    this.setState({ disabled: false });
  };

  handleClickDeleteOrphanCollection = () => {
    const deleteAtCollection = firebase
      .functions()
      .httpsCallable("deleteSubCollection");
    deleteAtCollection({ collection: this.state.collection });
  };

  resetPasswordCallback = (response) => {
    if (response === true) ProfileStore.message = i18n.login.emailSent;
    else
      ProfileStore.message = i18n.firebaseFunctions.sendPasswordResetEmail[
        response.code
      ]
        ? i18n.firebaseFunctions.sendPasswordResetEmail[response.code]
        : i18n.firebaseFunctions.sendPasswordResetEmail.error;
    ProfileStore.openSnackbar = true;
  };

  timeleft = () => {
    const time = LoginStore.timeLeft();
    let plural = time === 1 ? "" : "s";
    return `${time} ` + i18n.day + plural + " restante" + plural;
  };

  render() {
    const { classes, password } = this.props,
      { name, email, disabled } = this.state,
      emailVerified = LoginStore.userAuth
        ? LoginStore.userAuth.emailVerified
        : false,
      textField = {
        root: classes.textFieldRoot,
        input: classes.textFieldInput,
      };

    const isTrial = LoginStore.isTrialUser();

    return (
      <>
        <Grid container className={classes.container}>
          <div>
            <div className={classes.gridContent}>
              <div>
                <DropdownUploadImage />
              </div>
              <div>
                <TextField
                  inputProps={{
                    maxlength: "30",
                  }}
                  value={name}
                  classes={textField}
                  label={i18n.profile.name}
                  onChange={this.handleInputNameChangeEvent}
                  disabled={disabled}
                />
                {password && (
                  <FormControl
                    className={classes.textFieldRoot}
                    aria-describedby="component-text"
                  >
                    <InputLabel htmlFor="component-error">
                      {i18n.profile.email}
                    </InputLabel>
                    <Input
                      value={email}
                      className={classes.textFieldInput}
                      onChange={this.handleInputEmailChangeEvent}
                      disabled={isTrial ? true : disabled}
                      endAdornment={
                        <InputAdornment position="end">
                          {isTrial ? (
                            <Tooltip
                              title={
                                i18n.trialMessage.functionalityNotAvailable
                              }
                            >
                              <Padlock className={classes.lockIcon} />
                            </Tooltip>
                          ) : emailVerified ? (
                            <Check className={classes.checkIcon} />
                          ) : (
                            <Unverified className={classes.unverifiedIcon} />
                          )}
                        </InputAdornment>
                      }
                    />
                    {!emailVerified && (
                      <FormHelperText
                        id="component-text"
                        className={classes.formHelperTextError}
                      >
                        {i18n.profile.emailVerification.notVerified}.&nbsp;
                        <span
                          className={classes.formHelperLink}
                          onClick={this.handleSendEmailVerification}
                        >
                          {i18n.profile.emailVerification.sendAgain}
                        </span>
                      </FormHelperText>
                    )}
                  </FormControl>
                )}
                <div className={classes.actions}>
                  {password && (
                    <Button
                      variant="outlined"
                      color="primary"
                      disabled={disabled}
                      onClick={this.handleResetPassword}
                    >
                      {i18n.profile.password}
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={ProfileStore.disabledBtn}
                    style={{ float: "right" }}
                    onClick={this.handleSave}
                  >
                    {i18n.save}
                  </Button>
                </div>
                {!password && (
                  <div className={classes.accountButton}>
                    <AccountButton
                      onClick={this.handleOpenModalLinkCredencial}
                      text={i18n.profile.registerPassword}
                      Icon={Mail}
                    />
                  </div>
                )}
                {isTrial && (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      <Typography
                        component="p"
                        style={{
                          fontWeight: "500" as any,
                        }}
                      >
                        Status da conta:
                      </Typography>
                      <Paper
                        className={classes.root}
                        elevation={1}
                        style={{ padding: "12px 4px", width: "192px" }}
                      >
                        <Typography
                          component="p"
                          style={{
                            fontWeight: "700" as any,
                            textAlign: "center",
                          }}
                        >
                          Trial
                        </Typography>
                        <hr />
                        <Typography
                          component="p"
                          style={{
                            fontWeight: "400" as any,
                            textAlign: "center",
                            color: "#757575",
                            fontSize: "16px",
                          }}
                        >
                          {this.timeleft()}
                        </Typography>
                      </Paper>
                    </div>
                    <div style={{ display: "flex", alignItems: "flex-end" }}>
                      <Button
                        onClick={() => WBSStore.subscribeShowChange(true)}
                        className={classes.topBtn}
                        style={{ margin: "0px" }}
                      >
                        {i18n.trialRegister.subscribeNow02}
                      </Button>
                    </div>
                  </div>
                )}
                {/* {LoginStore.userAuth && LoginStore.userAuth.rubk && (
                  <div>
                    <div>
                      <Input
                        className={classes.textFieldInput}
                        onChange={this.handleInputDeleteOrphanCollection}
                      />
                    </div>
                    <div className={classes.actions}>
                      <Button
                        variant="outlined"
                        disabled={this.state.collection === ""}
                        color="primary"
                        onClick={this.handleClickDeleteOrphanCollection}
                      >
                        Excluir subcoleções
                      </Button>
                    </div>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </Grid>
      </>
    );
  }
}

export default withStyles(styles)(Profile);



// WEBPACK FOOTER //
// ./src/modules/profile/components/pages/Profile.tsx